// extracted by mini-css-extract-plugin
module.exports = {"FeedbackOptionDiv":"RatingModal_FeedbackOptionDiv__r0GDH","ModalHeading":"RatingModal_ModalHeading__0DZWv","TextArea":"RatingModal_TextArea__ks7em"};